import { AppDispatch, RootState } from '..';
import { getParcelDeliveriesSuccess, setParcelDeliveriesLoading } from '../reducers';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { headers } from '.';
import { notification } from '../../utils';

export const fetchParcelDeliveries = () => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(setParcelDeliveriesLoading(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/parcel-deliveries/company/${company?.company_id}`, headers(token));

    const { parcel_deliveries, message } = data;

    try {
        
        dispatch(getParcelDeliveriesSuccess(parcel_deliveries));

    } catch (error: any) {
        console.log(message || error.message);

    }
    finally {
        dispatch(setParcelDeliveriesLoading(false));
    }

};

export const addParcelDelivery = (values: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;
    const { company_id } = company;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/parcel-delivery/add`, { ...values, company_id }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchParcelDeliveries());
        
    } catch (error) {

        const { message }: any = error;
        notification('error', message);
        
    }
};

export const updateParcelDelivery = (values: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/parcel-delivery/update`, {...values}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchParcelDeliveries());
        
    } catch (error: any) {

        notification('error', message);
        console.log('Parcel delivery edit error: ', error.message);
        
    }
};

// export const deletePickupPoint = (pickup_point_id: string) => async (dispatch: AppDispatch, getState: RootState) => {

//     const { token } = getState().authReducer;

//     const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/pickup-point/${pickup_point_id}/delete`, headers(token));

//     const { success, message } = data;

//     try {

//         notification(success ? 'success' : 'error', message);
//         dispatch(fetchPickupPoints());
        
//     } catch (error: any) {

//         notification('error', message);
        
//     }
// };